<template>
  <div class="custom-bread-crumb">
    <el-breadcrumb separator=" ">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>{{tag1}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{tag2}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="tag3">{{tag3}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
import './custom-bread-crumb.less'
export default {
  name: 'customBreadCrumb',
  data () {
    return {
      tag1: '',
      tag2: '',
      tag3: ''
    }
  },
  components: {
    // CommonIcon
  },
  created () {
    this.tag1 = this.$route.meta.tag1
    this.tag2 = this.$route.meta.tag2
    this.tag3 = this.$route.meta.tag3
    this.$router.beforeEach((to, from, next) => {
      this.tag1 = to.meta.tag1
      this.tag2 = to.meta.tag2
      this.tag3 = to.meta.tag3
      next()
    })
  },
  methods: {
  }
}
</script>
